<ng-container *ngIf="loaded && record">
  <opac-card-item
    [title]="title"
    [author]="record.author"
    [issueDate]="checkout.issueDate"
    [cover]="coverDetails"
    [link]="record | infoUrl: { rhId: checkout.rssRhId }"
    [progress]="cardProgress"
  >
    <opac-card-item-social>
      <app-rating class="interactions__rating" [record]="record"></app-rating>
      <app-favorite-button *ngIf="!record?.fromBookClub" [recordId]="record?.id"></app-favorite-button>
      <app-more-option-button [recordItem]="record" [checkoutItem]="checkout" [isCheckoutItem]="true"></app-more-option-button>
    </opac-card-item-social>

    <ng-container *ngIf="!checkout.expired">
      <opac-card-item-details *ngIf="showExpireDate">
        <opac-card-item-detail [label]="'checkouts.expires' | translate">
          {{ checkout.endTime | date }} - {{ checkout.endTime | date:'shortTime' }}
        </opac-card-item-detail>

        <opac-card-item-detail [label]="'checkouts.left' | translate">
          {{ timeLeft }}
        </opac-card-item-detail>
      </opac-card-item-details>

      <app-record-buttons
        [record]="record"
        [checkoutItem]="checkout"
        [issueDate]="checkout?.issueDate"
        [config]="buttonConfig"
        [rssItem]="rssItem"
        (renewed)="onRenewal($event)">
      </app-record-buttons>
    </ng-container>

    <span *ngIf="checkout.expired" class="expired-tag">
      {{ 'general.expired' | translate }}
    </span>
  </opac-card-item>
</ng-container>
